<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!temp_id">{{ 'Add Personal document' | translate }}</v-card-title>
              <v-card-title v-if="temp_id">{{ 'Edit Personal document' | translate}}</v-card-title>
              <v-card-text style="position: relative">
                <v-form id="form" ref="form">
                <v-row v-if="errors">
                    <v-col cols="12" sm="12" md="12">
                    <v-alert
                        dense
                        v-for="(v, k) in errors"
                        :key="k"
                        outlined
                        type="error"
                    >{{ k }} {{ v }}</v-alert>
                    </v-col>
                </v-row>

                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Personal template name' | translate"
                            name="temp_name"
                            v-model="temp_name"
                            autocomplete="off"
                            :rules="personaldocumentnameRules"
                            required
                          >
                          <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            type='number'
                            min="0"  
                            :label="'Validity' | translate"
                            name="temp_validity"
                            v-model="temp_validity"
                            autocomplete="off"
                            :rules="validityRules"
                            required
                          >
                          <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="temp_id !== null ">
                        <v-col cols="12" sm="6">
                          <div class="pb-4 title">{{ 'Personal templates' | translate}}</div>
                        </v-col>
                        <v-col cols="12" sm="6" style="text-align:right;">
                            <v-btn small class="white--text" :color="primary_color" @click="openAddEditTemplateBox()" >{{ 'Add document'| translate }}</v-btn>
                        </v-col>
                        <v-divider></v-divider>                       
                      </v-row>


                      <v-row v-if="temp_id !== null ">
                        <v-col>
                          <DataTable
                            @editing='openeditTemplateBox'
                            @previewTemplate='previewTemplate'
                            :headers="headers"
                            :items="individualpersonaldocument.temp_files"
                          />                         
                        </v-col>
                      </v-row>


                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                    </v-col>
                  </v-row>
                </v-form>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="!temp_id"
                  class="mx-2"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="temp_id"
                  class="mx-2"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <TemplateBox
        v-if="addCertificationDialog"
        :addCertificationDialog="addCertificationDialog"
        @closeTemplateBox="closeTemplateBox"
        @addCustomLabel="addCustomLabel"
        :dragDropValues="dragDropValues"
        :key="addCertificationDialog"
        :temp_id="temp_id"
        :previewSlug="'all-templates/preview'"
        :updateSlug="'templates/personal'"
        :getData="getData"
        :temp_validity="temp_validity"
        :editSlug="'templates/personal/view-file/'"
        :editTemplate="editValues"
        :title="templateEditTitle"
       />
    </v-container> 
  </v-content>
</template>  

<script>
import {
  FETCH_INDIVIDUAL_PERSONAL_DOCUMENT,
  ADD_PERSONAL_DOCUMENT,
  UPDATE_PERSONAL_DOCUMENT,
  DOWNLOAD_PERSONAL_DOCUMENT,
  RESET_STATE
} from "@/store/actions.type";
import store from "@/store"
import mixins from "@/mixins/mixins"
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import { SET_SNACKBAR, SET_LOADING } from "@/store/mutations.type"
export default {
  name: "addeditditPersonalTemplate",
  mixins: [mixins], 
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE);     
    if (to.params.id) {
      store.dispatch(FETCH_INDIVIDUAL_PERSONAL_DOCUMENT, to.params.id).then(resp => {
        if (resp.success) {
            store.commit(SET_LOADING, false);
        }
     });    
    }
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["individualpersonaldocument",'curLanguage', 'currentUser']),
    ...mapState({
      errors: state => state.documents.documenterrors
    }),
    headers(){
        return [
            { text: this.$t('Upload date'), value: 'updated_at' },
            { text: this.$t('Status'), value: 'status' },
            { text: this.$t('Actions'), value: 'personaldocumentaction', sortable: false },
        ]
    },
    personaldocumentnameRules(){
      return [v => !!v || "Personal template name is required"]
    },
    validityRules(){
      return [v => !!v || "Validity is required"]
    },
    templatefileRules(){ 
        return [
            v => !!v || 'Template file is required',
              
        ]
    },    
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    TemplateBox: () => import("@/components/custompdf/custompdf")
  },    
  watch: {
      individualpersonaldocument(val) {
          if(Object.keys(val).length > 0){
              this.temp_name = this.individualpersonaldocument.temp_name
              this.temp_id    =   this.individualpersonaldocument.temp_id
              this.temp_validity     =   this.individualpersonaldocument.temp_validity
              this.dragDropValues = JSON.parse(this.individualpersonaldocument.drag_meta_data)
          }
      }
  },
  data: () => ({
    temp_name: null,
    temp_id: null,
    temp_validity: null,
    file: null,
    title: 'Personal template',   
    dialog: false,  
    filename: null,    
    primary_color: null,
    editValues: {},
    addCertificationDialog: false,
    editTemplate: false,
    temp_file: null,
    dragDropValues:[],
    templateEditTitle: 'Add template',
    getData: FETCH_INDIVIDUAL_PERSONAL_DOCUMENT,
  }),
  created (){
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }
    let company_meta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = company_meta.primary_color;
  },
  methods: {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('can-create-personal-template') || this.currentUser.permissions.includes('can-update-personal-template') ){
        return true;
      }
      return false;
    },
    openeditTemplateBox(item) {
        this.editValues = item
        this.templateEditTitle = 'Edit personal template'
        this.addCertificationDialog = true
    },
    previewTemplate(id){
        this.handlePreview('all-templates/preview',id)
    },
    closeBox(){
        this.file = null
        this.filename =null
        document.getElementById("documentform").reset();
        this.dialog = false
    },
    openAddEditTemplateBox(){
        this.addCertificationDialog = true
    },
    closeTemplateBox () {
        this.editValues = {}
        this.templateEditTitle = 'Add template'
        this.editTemplate = false
        this.addCertificationDialog = false
    },
    openPersonalTemplateDocumentModal(){
      this.dialog =true
    },
    addCustomLabel(item){
        this.dragDropValues = [ ...item ]
        this.editTemplate = true
        this.update()
    },
    async updateDocument(){
        var documentformData = new FormData(document.getElementById("documentform"));
        documentformData.set("temp_name", this.individualpersonaldocument.temp_name);
        documentformData.set("temp_validity", this.individualpersonaldocument.temp_validity);
        documentformData.set("temp_id", this.temp_id);
        documentformData.set("_method", "put");
        if (this.file != null) {
            documentformData.append("temp_files", this.file);
        }
        this.$store.dispatch(UPDATE_PERSONAL_DOCUMENT, documentformData).then(resp => {
            if (resp.success) {
                this.$store.dispatch(FETCH_INDIVIDUAL_PERSONAL_DOCUMENT, this.individualpersonaldocument.temp_id).then(resp=>{
                    if(resp.success){
                        this.$store.commit(SET_SNACKBAR, {status: true, message: 'Personal template updated successfully'})
                        this.file = null
                        this.filename =null
                        this.closeBox();
                        store.commit(SET_LOADING, false);
                    }
                })
            }
        }); 
    },  
    submit() {
        if (this.$refs.form.validate()) {
            var formData = new FormData(document.getElementById("form"));
            if (this.file != null) {
                formData.append("temp_files", this.file);
            }
            this.$store.dispatch(ADD_PERSONAL_DOCUMENT, formData).then(resp => {
            if (resp.success) {
               store.commit(SET_SNACKBAR, {status: true, message: 'Personal template added successfully'})
                this.file = null
                this.$router.push({
                name: "personaltemplate",
                });
            }
            });            
            
        }
    },
    async downloadFile(documentdata){
      await this.$store
        .dispatch(DOWNLOAD_PERSONAL_DOCUMENT, 'view-file/'+documentdata.temp_file_id)
        .then(resp => {
          this.downloadDocument(this.individualpersonaldocument.temp_name, resp,documentdata)
          store.commit(SET_LOADING, false);
        });
    },

  
    update() {
        if (this.$refs.form.validate()) {
        var formData = new FormData(document.getElementById("form"));
        formData.set("temp_id", this.temp_id); 
        formData.set("drag_meta_data",JSON.stringify(this.dragDropValues))
        formData.set("_method", "put");
            if (this.file != null) {
                formData.append("temp_files", this.file);
            }        
        this.$store.dispatch(UPDATE_PERSONAL_DOCUMENT, formData).then(resp => {
        if (resp.success && !this.editTemplate) {
            this.$store.commit(SET_SNACKBAR, {status: true, message: 'Personal template updated successfully'})
            this.$router.push({
            name: "personaltemplate",
            });
        }
        if(this.editTemplate){
            this.dragDropValues = JSON.parse(resp.data.drag_meta_data)
            this.$store.dispatch(FETCH_INDIVIDUAL_PERSONAL_DOCUMENT, this.temp_id)
        }
        });              
        }        
    },
  }
};
</script>